// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Timeline container ── */
.lt___container {
  position: relative;
  padding-left: 40px;
  padding-bottom: 16px;
  margin-top: 8px;
}

/* Static background track */
.lt___track {
  position: absolute;
  left: 15px;
  top: 16px;
  bottom: 32px;
  width: 2px;
  background: #f1f5f9;
  z-index: 0;
}

/* Emerald progress fill */
.lt___progress {
  position: absolute;
  left: 15px;
  top: 16px;
  width: 2px;
  background: #34d399;
  transition: height 0.5s ease;
  z-index: 1;
}

/* Each step row */
.lt___step {
  position: relative;
  margin-bottom: 40px;
}

.lt___step:last-child {
  margin-bottom: 0;
}

/* Circular dot */
.lt___dot {
  position: absolute;
  left: -40px;
  top: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.lt___dot--green {
  background: #d1fae5;
}

.lt___dot--slate {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.lt___dot-icon--green {
  color: #059669;
  display: flex;
}

.lt___dot-icon--slate {
  color: #94a3b8;
  display: flex;
}

/* Content row (title+desc LEFT, time RIGHT) */
.lt___content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.lt___left {
  flex: 1;
  min-width: 0;
}

/* Title row */
.lt___title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.lt___title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  font-family: "Outfit", "Inter", sans-serif;
}

.lt___check-icon {
  flex-shrink: 0;
}

.lt___badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background: #ffebee;
  color: #d32f2f;
}

/* Description */
.lt___desc {
  font-size: 13px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

/* Time chip */
.lt___time {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
  padding-top: 2px;
}

/* Action buttons */
.lt___actions {
  display: flex;
  gap: 10px;
  margin-top: 14px;
  flex-wrap: wrap;
}

.lt___action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid;
  background: #fff;
  transition: background 0.15s ease;
  font-family: "Outfit", "Inter", sans-serif;
}

.lt___action-btn--warning {
  border-color: #fdba74;
  color: #ea580c;
}

.lt___action-btn--warning:hover {
  background: #fff7ed;
}

.lt___action-btn--primary {
  border-color: #93c5fd;
  color: #2563eb;
}

.lt___action-btn--primary:hover {
  background: #eff6ff;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/ThirdPartyLogistics/components/LogisticsTimeline.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ── Timeline container ── */\n.lt___container {\n  position: relative;\n  padding-left: 40px;\n  padding-bottom: 16px;\n  margin-top: 8px;\n}\n\n/* Static background track */\n.lt___track {\n  position: absolute;\n  left: 15px;\n  top: 16px;\n  bottom: 32px;\n  width: 2px;\n  background: #f1f5f9;\n  z-index: 0;\n}\n\n/* Emerald progress fill */\n.lt___progress {\n  position: absolute;\n  left: 15px;\n  top: 16px;\n  width: 2px;\n  background: #34d399;\n  transition: height 0.5s ease;\n  z-index: 1;\n}\n\n/* Each step row */\n.lt___step {\n  position: relative;\n  margin-bottom: 40px;\n}\n\n.lt___step:last-child {\n  margin-bottom: 0;\n}\n\n/* Circular dot */\n.lt___dot {\n  position: absolute;\n  left: -40px;\n  top: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.lt___dot--green {\n  background: #d1fae5;\n}\n\n.lt___dot--slate {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n\n.lt___dot-icon--green {\n  color: #059669;\n  display: flex;\n}\n\n.lt___dot-icon--slate {\n  color: #94a3b8;\n  display: flex;\n}\n\n/* Content row (title+desc LEFT, time RIGHT) */\n.lt___content {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.lt___left {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Title row */\n.lt___title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.lt___title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.lt___check-icon {\n  flex-shrink: 0;\n}\n\n.lt___badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  background: #ffebee;\n  color: #d32f2f;\n}\n\n/* Description */\n.lt___desc {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Time chip */\n.lt___time {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #94a3b8;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n  padding-top: 2px;\n}\n\n/* Action buttons */\n.lt___actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 14px;\n  flex-wrap: wrap;\n}\n\n.lt___action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid;\n  background: #fff;\n  transition: background 0.15s ease;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.lt___action-btn--warning {\n  border-color: #fdba74;\n  color: #ea580c;\n}\n\n.lt___action-btn--warning:hover {\n  background: #fff7ed;\n}\n\n.lt___action-btn--primary {\n  border-color: #93c5fd;\n  color: #2563eb;\n}\n\n.lt___action-btn--primary:hover {\n  background: #eff6ff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
